import { render, staticRenderFns } from "./Catalog.vue?vue&type=template&id=7bc3e4b6&scoped=true"
import script from "./Catalog.vue?vue&type=script&lang=ts"
export * from "./Catalog.vue?vue&type=script&lang=ts"
import style0 from "./Catalog.vue?vue&type=style&index=0&id=7bc3e4b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc3e4b6",
  null
  
)

export default component.exports